/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_statuses_pending_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Čekání na platbu`
};

const da_order_statuses_pending_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Afventer betaling`
};

const de_order_statuses_pending_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Zahlung ausstehend`
};

const en_order_statuses_pending_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Pending payment`
};

const es_order_statuses_pending_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Pendiente de pago`
};

const fr_order_statuses_pending_payment = /** @type {(inputs: {}) => string} */ () => {
	return `En attente de paiement`
};

const hu_order_statuses_pending_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Fizetésre vár`
};

const it_order_statuses_pending_payment = /** @type {(inputs: {}) => string} */ () => {
	return `In attesa di pagamento`
};

const nl_order_statuses_pending_payment = /** @type {(inputs: {}) => string} */ () => {
	return `In afwachting van betaling`
};

const pl_order_statuses_pending_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Oczekuje na płatność`
};

const pt_order_statuses_pending_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Aguardando pagamento`
};

const sv_order_statuses_pending_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Väntar på betalning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_statuses_pending_payment = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_statuses_pending_payment(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_statuses_pending_payment", locale)
	if (locale === "cs") return cs_order_statuses_pending_payment(inputs)
	if (locale === "da") return da_order_statuses_pending_payment(inputs)
	if (locale === "de") return de_order_statuses_pending_payment(inputs)
	if (locale === "en") return en_order_statuses_pending_payment(inputs)
	if (locale === "es") return es_order_statuses_pending_payment(inputs)
	if (locale === "fr") return fr_order_statuses_pending_payment(inputs)
	if (locale === "hu") return hu_order_statuses_pending_payment(inputs)
	if (locale === "it") return it_order_statuses_pending_payment(inputs)
	if (locale === "nl") return nl_order_statuses_pending_payment(inputs)
	if (locale === "pl") return pl_order_statuses_pending_payment(inputs)
	if (locale === "pt") return pt_order_statuses_pending_payment(inputs)
	return sv_order_statuses_pending_payment(inputs)
};
export { order_statuses_pending_payment as "order_statuses.pending_payment" }